// extracted by mini-css-extract-plugin
module.exports = {"main":"error-message_main__qQc8H"};